import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon, MenuIcon, MessageCircleIcon, PhoneIcon, XIcon } from 'lucide-react';
import { Logo } from '../Logo';
import { nav, site } from '../../data/site';
export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => setOpen(false), [location.pathname]);
  useEffect(() => {
    const scroller = document.getElementById('main');
    const onScroll = () => setScrolled((scroller?.scrollTop ?? window.scrollY) > 24);
    onScroll();
    scroller?.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => {
      scroller?.removeEventListener('scroll', onScroll);
      window.removeEventListener('scroll', onScroll);
    };
  }, []);
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  return <>
      <header className={`safe-top fixed inset-x-0 top-0 z-50 transition-colors duration-200 ease-smooth ${scrolled || open ? 'border-b border-edge bg-void/90 backdrop-blur-xl' : 'border-b border-transparent'}`} data-id="element-702" data-mp="bsoty7zw65vz">
        <div className="mx-auto flex h-16 max-w-shell items-center justify-between gap-3 px-4 sm:px-6 lg:h-20 lg:px-10" data-id="element-703" data-mp="3k3i9eisavxpd">
          <Link to="/" aria-label="Daily Car Care — home" data-id="element-704" data-mp="3p1jsv4tn1z1d">
            <Logo data-id="element-705" data-mp="3u04rizt8sanp" />
          </Link>

          <nav aria-label="Hoofdnavigatie" className="hidden items-center gap-9 lg:flex" data-id="element-706" data-mp="3tz3744qc6btb">
            {nav.map(item => <NavLink key={item.to} to={item.to} className={({
            isActive
          }) => `text-sm transition-colors duration-200 ease-smooth ${isActive ? 'text-ember' : 'text-dim hover:text-chalk'}`} data-id="element-707" data-mp="19a5qlaam71ul">
                {item.label}
              </NavLink>)}
          </nav>

          <div className="flex items-center gap-2 lg:gap-3" data-id="element-708" data-mp="3jcta69a54iva">
            <Link to="/book" className="hidden rounded-full bg-ember px-5 py-2.5 text-sm font-semibold text-void transition-[background-color,box-shadow] duration-200 ease-smooth hover:bg-white hover:glow lg:inline-flex" data-id="element-709" data-mp="3jca1lj6dr6tx">
              Afspraak maken
            </Link>
            <a href={site.phoneHref} aria-label={`Bel ${site.phone}`} className="flex h-11 w-11 items-center justify-center rounded-full border border-edge text-chalk transition-colors duration-200 ease-smooth active:border-ember active:text-ember lg:hidden" data-id="element-710" data-mp="2mkzgp0ipxs8m">
              <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-711" data-mp="22ytgvh5svrh0" />
            </a>
            <button type="button" onClick={() => setOpen(v => !v)} className="flex h-11 w-11 items-center justify-center rounded-full border border-edge text-chalk lg:hidden" aria-expanded={open} aria-label={open ? 'Menu sluiten' : 'Menu openen'} data-id="element-712" data-mp="22wz3qp0rt3nh">
              {open ? <XIcon className="h-5 w-5" data-id="element-713" data-mp="eee58t5lfau9" /> : <MenuIcon className="h-5 w-5" data-id="element-714" data-mp="efp5iizty0gm" />}
            </button>
          </div>
        </div>
      </header>

      <AnimatePresence data-id="element-715" data-mp="125jgsw4i3gyr">
        {open && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed inset-0 z-[45] bg-void lg:hidden" data-id="element-716" data-mp="166vcnjdywyfe">
            <motion.nav aria-label="Mobiele navigatie" initial={{
          y: 16,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} exit={{
          y: 8,
          opacity: 0
        }} transition={{
          duration: 0.22,
          ease: [0.23, 1, 0.32, 1]
        }} className="safe-bottom flex h-full flex-col overflow-y-auto px-5 pb-8 pt-20" data-id="element-717" data-mp="3cwt4j666fthy">
              <ul className="space-y-1" data-id="element-718" data-mp="3scq31v0a1k2h">
                {nav.map(item => <li key={item.to} data-id="element-719" data-mp="3odr02fy3vxdo">
                    <NavLink to={item.to} className={({
                isActive
              }) => `flex items-center justify-between border-b border-edge/70 py-4 font-display text-2xl font-extrabold tracking-tightest ${isActive ? 'text-ember' : 'text-chalk'}`} data-id="element-720" data-mp="3je4osc1u8r7i">
                      {item.label}
                      <ArrowRightIcon className="h-5 w-5 text-dim" aria-hidden="true" data-id="element-721" data-mp="601e9pxiql6f" />
                    </NavLink>
                  </li>)}
                <li data-id="element-722" data-mp="2vm7eipe1e78i">
                  <NavLink to="/appointment" className={({
                isActive
              }) => `flex items-center justify-between py-4 font-display text-2xl font-extrabold tracking-tightest ${isActive ? 'text-ember' : 'text-chalk'}`} data-id="element-723" data-mp="2qpqrjyikpyx0">
                    Mijn afspraak
                    <ArrowRightIcon className="h-5 w-5 text-dim" aria-hidden="true" data-id="element-724" data-mp="2va6iyzzbtqsr" />
                  </NavLink>
                </li>
              </ul>

              <div className="mt-auto space-y-3" data-id="element-725" data-mp="2zbs0wzqpwv9t">
                <Link to="/book" className="flex items-center justify-center gap-2 rounded-full bg-ember px-6 py-4 text-sm font-semibold text-void" data-id="element-726" data-mp="34aldmpy6ki8x">
                  Afspraak maken
                  <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-727" data-mp="3e8sgy5zjr1sg" />
                </Link>
                <div className="grid grid-cols-2 gap-3" data-id="element-728" data-mp="1exhumb064d76">
                  <a href={site.phoneHref} className="flex items-center justify-center gap-2 rounded-full border border-edge px-4 py-3.5 text-sm text-chalk" data-id="element-729" data-mp="1jv00fsiw2cay">
                    <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-730" data-mp="16wac8z9mmx0q" />
                    Bellen
                  </a>
                  <a href={site.whatsapp} target="_blank" rel="noreferrer" className="flex items-center justify-center gap-2 rounded-full border border-edge px-4 py-3.5 text-sm text-chalk" data-id="element-731" data-mp="1ltj8a69vkoys">
                    <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-732" data-mp="1ptbeicbsqj0z" />
                    WhatsApp
                  </a>
                </div>
                <p className="pt-2 text-center text-xs text-dim" data-id="element-733" data-mp="1zk64nrs5y2rp">{site.address}</p>
              </div>
            </motion.nav>
          </motion.div>}
      </AnimatePresence>
    </>;
}